import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-curves",
  "use": "icon-leo-e1-curves-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-curves\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 800V224h64v512h640v64H160z\" />\r\n  <path d=\"M256 640l160-192 128 96 224-288 52 40-256 328-128-96-128 160-52-48z\" />\r\n  <circle cx=\"416\" cy=\"448\" r=\"40\" />\r\n  <circle cx=\"544\" cy=\"544\" r=\"40\" />\r\n  <circle cx=\"768\" cy=\"256\" r=\"40\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-curves.svg
// module id = yk1X
// module chunks = 478